import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { WorkflowTestRepository } from "../domain/WorkflowRepositories";
import { WorkflowTest } from "../domain/WorkflowTest";

function objectToDict(obj: any): Record<string, any> {
    const dict: Record<string, any> = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Recursively convert nested object
                dict[key] = objectToDict(value);
            } else {
                dict[key] = value;
            }
        }
    }

    return dict;
}


export class ApiWorkflowTestRepository implements WorkflowTestRepository{
    
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor() {
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }

    api_to_domain(wf) {
        let id = wf.id
        let name = wf.name
        let input = wf.input || {}
        let assert_script = wf.assert_script || ""
        let company_id = wf.company_id || 0
        let description = wf.description || ""
        let last_run = wf.last_run || ""
        let passed = wf.passed
        let errors = wf.errors || []
        let workflow_template_id = wf.workflow_template_id || 0
        let state = wf.state || ""
        let output = wf.output || {}
        return new WorkflowTest( workflow_template_id, input, assert_script, company_id, id, name, description,state, last_run, passed, errors,output );
    }

    domain_to_api(wf: WorkflowTest) {
        return JSON.parse(JSON.stringify(objectToDict(wf)));
    }

    async get_workflow_tests(sort_by: string, limit: number, offset: number): Promise<any>{
        //let res = [{'name':'test1', 'id':1, 'input':{}, 'assert_script':'', 'company_id':1, 'description':'test description', 'last_run':'2023-10-01', 'passed':true, 'errors':[], 'workflow_template_id':1, 'state':''}];
        let res = await this.query_dispatcher.dispatch('get.user.workflow.tests', {'force_get':true})
        console.log(res)
        return {'results':res.results.map(wf => this.api_to_domain(wf)), 'count': res.count};
    }
    async save_workflow_test(workflow_test: WorkflowTest): Promise<any>{
        let res = await this.sync_command_dispatcher.dispatch('save.workflow.test', {workflow_test: this.domain_to_api(workflow_test)});
        // Check for errors in response
        if (res && res.output && res.output.error) {
            return { error: res.output.error || res.output.message || 'Error saving test' };
        }
        return 'ok';
    }
    
    async run_test(workflow_test: WorkflowTest): Promise<any> {
        let res = await this.async_command_dispatcher.dispatch('run.workflow.test', {'test_ids': [workflow_test.id]});
        console.log('Running test:', workflow_test);
        return res
    }
}